import { useIsMobile } from '@/hooks/use-is-mobile';
import { forwardRef } from 'react';
import { BannerCardV3Desktop } from './desktop';
import { BannerCardV3Mobile } from './mobile';
import { BannerCardV3Props } from './types';

export const BannerCardV3 = forwardRef<HTMLDivElement, BannerCardV3Props>(
    (props, ref) => {
        const isMobile = useIsMobile();
        return isMobile ? (
            <BannerCardV3Mobile ref={ref} {...props} />
        ) : (
            <BannerCardV3Desktop ref={ref} {...props} />
        );
    }
);

BannerCardV3.displayName = 'BannerCardV3';
